import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            
            {/* Left Section - Copyright */}
            <div className="text-sm text-gray-500">
              &copy; 2025 VARAi Inc. Practice Studio is a product of VARAi.
            </div>
            
            {/* Center Section - Essential Healthcare Links */}
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <Link
                to="/demo"
                className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors duration-200"
              >
                🎯 Live Demo
              </Link>
              <Link
                to="/pms-platforms"
                className="text-cyan-600 hover:text-cyan-800 font-medium transition-colors duration-200"
              >
                🔗 PMS Integrations
              </Link>
              <Link
                to="/faq"
                className="text-orange-600 hover:text-orange-800 font-medium transition-colors duration-200"
              >
                ❓ FAQ
              </Link>
              <Link
                to="/privacy-policy"
                className="text-gray-600 hover:text-gray-800 transition-colors duration-200"
              >
                Privacy Policy
              </Link>
              <Link
                to="/support"
                className="text-purple-600 hover:text-purple-800 transition-colors duration-200"
              >
                Support
              </Link>
            </div>
            
            {/* Right Section - Compliance Badge */}
            <div className="flex items-center text-xs text-gray-500">
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
                Built with HIPAA safeguards in mind
              </span>
            </div>
          </div>
          
          {/* Additional Compliance Information */}
          <div className="mt-3 pt-3 border-t border-gray-100">
            <div className="flex flex-col sm:flex-row justify-between items-center text-xs text-gray-400 space-y-2 sm:space-y-0">
              <div>
                AI-powered retail management plugin for eyewear practices &middot; <a href="https://varai.com" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300">varai.com</a>
              </div>
              <div>
                <span className="inline-flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  System Status: Operational
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;